var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M12.32 12.36l12.35-8.51 12.23 8.51M34.36 10.59v15.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.88 28.53c0 5.41-5.15 9.8-11.5 9.8s-11.49-4.39-11.49-9.8c0-1.8.57-3.49 1.57-4.94-.37-.33-.67-.75-.83-1.24-.61-1.77.58-3.79 2.65-4.5 1.85-.65 3.78-.04 4.61 1.35a13.323 13.323 0 017.05.01c.83-1.4 2.77-2.01 4.62-1.36 2.07.72 3.26 2.73 2.65 4.5-.17.5-.48.93-.87 1.27.98 1.44 1.54 3.11 1.54 4.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 17.38,
    cy: 31.01,
    r: 1.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.4 26.2v.85M21.16 26.2v.85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildSupport);
export default __webpack_public_path__ + "static/media/childSupport.0df9abd85c5d2d8a22ca7dd53046fb8f.svg";
export { ForwardRef as ReactComponent };